var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultProfileDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "profile_round-_1346_",
    "data-name": "profile_round-[#1346]",
    d: "M334.562,1963.5a3.063,3.063,0,1,0-3.062,3,3.034,3.034,0,0,0,3.062-3m2.9,10.5h-1.366a.75.75,0,1,1,0-1.5h.329a.746.746,0,0,0,.72-1,6.3,6.3,0,0,0-11.284,0,.746.746,0,0,0,.72,1h.328a.75.75,0,1,1,0,1.5H325.54a1.5,1.5,0,0,1-1.508-1.773,7.14,7.14,0,0,1,4.59-5.222,4.455,4.455,0,0,1-1.717-3.5,4.6,4.6,0,0,1,9.134-.7,4.451,4.451,0,0,1-1.663,4.2,7.139,7.139,0,0,1,4.59,5.222,1.5,1.5,0,0,1-1.507,1.773m-3.663-.75a.758.758,0,0,1-.765.75h-3.063a.75.75,0,1,1,0-1.5h3.063a.758.758,0,0,1,.765.75",
    transform: "translate(-324 -1959)",
    fill: "#ddd",
    fillRule: "evenodd"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfileDark);
export default __webpack_public_path__ + "static/media/defaultProfileDark.9fb6df487f38cd84f59d0b9d06e0d3a4.svg";
export { ForwardRef as ReactComponent };